import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "@/components/Reveal";
import { CreationCard } from "@/components/game/CreationCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HomeGallery = () => {
  const { t } = useLang();
  const s = t.gallery;
  const [items, setItems] = useState([]);
  useEffect(() => { axios.get(`${API}/creations?limit=4`).then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (!items.length) return null;
  return (
    <section className="max-w-7xl mx-auto px-5 md:px-8 py-24 md:py-36" data-testid="home-gallery-section">
      <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-[#C86A4B] font-bold mb-3">{s.homeKicker}</p>
          <h2 className="font-serif-d text-4xl md:text-5xl font-semibold text-[#132A1D] tracking-tight whitespace-pre-line">{s.homeTitle}</h2>
          <p className="text-[#5C5C5C] mt-4 max-w-md leading-relaxed">{s.homeSub}</p>
        </Reveal>
        <Reveal delay={0.1} className="flex flex-wrap gap-3">
          <Link to="/tablero" data-testid="home-gallery-play" className="inline-flex items-center gap-2 rounded-full bg-[#2E5A3B] text-white px-6 py-3 text-sm font-semibold hover:bg-[#C86A4B] transition-colors duration-300">{s.homePlay} <ArrowRight size={16} /></Link>
          <Link to="/galeria" data-testid="home-gallery-cta" className="inline-flex items-center gap-2 rounded-full border border-black/15 text-[#132A1D] px-6 py-3 text-sm font-semibold hover:bg-[#EFECE6] transition-colors duration-300">{s.homeCta}</Link>
        </Reveal>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6" data-testid="home-gallery-grid">
        {items.map((c, i) => <Reveal key={c.id} delay={0.06 * i}><CreationCard c={c} /></Reveal>)}
      </div>
    </section>
  );
};
